const $accordeonItems = $('.accordeon-item');
const $accordeonContents = $('.accordeon-item__content');

//$('.accordeon-item__button, .accordeon-item__title').on('click', function() {
App.H.on('click', '.accordeon-item__button, .accordeon-item__title', function() {
    const $item = $(this).closest('.accordeon-item');
    const _isActive = $item.is('._active');

    $accordeonItems.removeClass('_active');
    $accordeonContents.clearQueue().slideUp(200);

    if ( _isActive ) {
        //$item.find('.accordeon-item__content').clearQueue().slideUp(200);
        $item.find('.accordeon-item__content').clearQueue().slideUp(200, function() {
            $item.find('.accordeon-item__content').removeAttr('style');
        });
    } else {
        $item.addClass('_active');
        $item.find('.accordeon-item__content').clearQueue().slideDown(200);
    }
});



const $toggleItems = $('.js-toggle-item');
const $toggleContents = $('.js-toggle-content');

//$('.js-toggle-btn, .js-toggle-link').on('click', function(e) {
App.H.on('click', '.js-toggle-btn, .js-toggle-link', function(e) {
    e.preventDefault();

    //const _isAccordeon = $(this).closest('.js-toggle-block').hasClass('_accordeonable');
    const _isAccordeon = $(this).closest('.js-toggle-item').hasClass('_accordeonable');
    const $item = $(this).closest('.js-toggle-item');
    const $itemContent = $item.find('.js-toggle-content');
    const _isActive = $item.is('._active');

    if (_isAccordeon) {
        $toggleItems.removeClass('_active');
        $toggleContents.clearQueue().slideUp(200);

        if ( _isActive ) {
            $item.find('.js-toggle-content').clearQueue().slideUp(200);
        } else {
            $item.addClass('_active');
            $item.find('.js-toggle-content').clearQueue().slideDown(200);
        }
    } else {
        $item.toggleClass('_active');
        $itemContent.clearQueue().slideToggle(200);
    }
});



// WEBPACK FOOTER //
// ./_src/js/modules/Accordeon.js